var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPirelli(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 50,
    viewBox: "0 0 228 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_2884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1505 23.7539H86.7651C91.5793 23.7539 95.4817 27.6754 95.4817 32.5131C95.4817 36.1963 93.2205 39.3665 89.9928 40.6492L96.1017 49.5H79.252L74.912 41.2722H71.1007V49.5H57.1505V23.7539ZM78.1214 29.2146H71.1372V35.3534H78.1397C79.8173 35.3534 81.2032 33.979 81.2032 32.2932C81.2032 30.6073 79.8356 29.233 78.1397 29.233",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.431 43.8377H172.783V49.5H143.952V23.7539H158.431V43.8377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.185 43.8377H135.892V49.5H103.432V23.7539H134.287V29.4162H118.185V33.7958H134.287V39.4581H118.185V43.8377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.438 43.8377H205.789V49.5H176.94V23.7539H191.438V43.8377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H219.028C223.97 0.5 227.982 4.53141 227.982 9.49738C227.982 14.4634 223.97 18.4948 219.028 18.4948H24.4175V49.5H0V0.5ZM192.076 6.43717H24.4175V12.4476H192.076C193.717 12.4476 195.066 11.1099 195.066 9.44241C195.066 7.77487 193.735 6.43717 192.076 6.43717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7591 23.7539H33.8088V49.5H47.7591V23.7539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.769 23.7539H209.819V49.5H223.769V23.7539Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_2884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 49,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirelli);
export default __webpack_public_path__ + "static/media/pirelli.4df78cb16c3519bb5c87d93ff9ed42ae.svg";
export { ForwardRef as ReactComponent };